module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-circle-77321307.svg";